import React, { Component } from 'react';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import arrayMutators from 'final-form-arrays';

import {
  FieldTextInput,
  Form,
  Button,
} from '../../components';

import FilesField from './FilesField';

import css from './FileUploadForm.module.css';

export class FileUploadForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        mutators={{ ...arrayMutators }}
        initialValues={{
          ...this.props.initialValues,
          invoice: [undefined],
          contract: [undefined],
          signedContract: [undefined],
        }}
        render={formRenderProps => {
          const {
            className,
            handleSubmit,
            disabled,
            ready,
            updated,
            updateInProgress,
            form,
            form: {
              mutators: { push },
            },
            values,
            fieldType,
          } = formRenderProps;

          const submitReady = updated || ready;
          const submitInProgress = updateInProgress;

          const disabledForProvider = (!values?.invoice?.[0] && !values?.contract?.[0]) || disabled || submitInProgress || ready;
          const disabledForCustomer = !values?.signedContract?.[0] || disabled || submitInProgress || ready;

          const submitDisabled = fieldType === "providerDocuments" ? disabledForProvider : disabledForCustomer;

          const classes = classNames(css.root, className);

          return (
            <Form className={classes} onSubmit={handleSubmit}>
              {fieldType === "providerDocuments" ? (
                <>
                  <h2 className={css.formTitle}>
                    <FormattedMessage id="TransactionPanel.documentsCutomerTitle" />
                  </h2>

                  <div className={css.fileHolder}>

                    <div className={css.fileItem}>
                      <h3 className={css.fileTitle}>
                        <FormattedMessage id="TransactionPanel.invoice" />
                      </h3>
                      <FilesField
                        key='invoice'
                        id='invoice'
                        fieldName='invoice'
                        mutatorsPush={push}
                        usePreviewIcon
                      />
                    </div>

                    <div className={css.fileItem}>
                      <h3 className={css.fileTitle}>
                        <FormattedMessage id="TransactionPanel.contract" />
                      </h3>
                      <FilesField
                        key='contract'
                        id='contract'
                        fieldName='contract'
                        mutatorsPush={push}
                        usePreviewIcon
                      />
                    </div>
                  </div>

                </>
              ) : (
                <>
                  <h2 className={css.formTitle}>
                    <FormattedMessage id="TransactionPanel.documentsProviderTitle" />
                  </h2>

                  <div className={css.fileItem}>
                    <h3 className={css.fileTitle}>
                      <FormattedMessage id="TransactionPanel.contract" />
                    </h3>
                    <FilesField
                      key='signedContract'
                      id='signedContract'
                      fieldName='signedContract'
                      mutatorsPush={push}
                      usePreviewIcon
                    />
                  </div>
                </>
              )}

              <Button
                type="submit"
                className={css.submitButton}
                disabled={submitDisabled}
              >
                <FormattedMessage id="TransactionPanel.upload" />
              </Button>
            </Form>
          );
        }}
      />
    );
  }
}

export default compose(injectIntl)(FileUploadForm);
